import LogDB from "@/views/logs/tabs/db.vue";
import LogFile from "@/views/logs/tabs/file.vue";
import LogView from '@/views/logs/view.vue';

export default [
    {
        path: "/logs",
        name: "logs_view",
        component: LogView,
        props: true,
        meta: { title: "Logs" },
        children: [
            {path: "file", component: LogFile, props: false, name: "logs_file", meta: { title: "Log files" }},
            {path: "db", component: LogDB, props: false, name: "logs_db", meta: { title: "Database Logs" }},
        ]
    },
];
